export default __webpack_public_path__ + "static/TX1-ES-bdba7cf4c0e379b9029d35350188af94.svg";